module.exports = __webpack_public_path__ + "static/structure-and-interpretation-of-computer-programs-258cd322685b5abb6533037ac035cd2d.jpg";